/* eslint-disable react/react-in-jsx-scope */
import * as Yup from 'yup';
import DateFormatter from 'components/DateFormatter';

export const categoryColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  { accessorKey: 'name', header: 'CATEGORY', sort: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,

    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', sort: true },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
  { accessorKey: 'actions', header: '', sort: true },
];

export const productColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'category',
    header: 'CATEGORY',
    sort: false,
    cell: ({ row }) => <div>{row?.original?.category?.name}</div>,
  },
  { accessorKey: 'name', header: 'PRODUCT', sort: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,

    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', sort: true },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
  { accessorKey: 'actions', header: '', sort: true },
];

export const subCategoryColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'product',
    header: 'PRODUCT',
    sort: false,
    cell: ({ row }) => <div>{row?.original?.product?.name}</div>,
  },
  { accessorKey: 'name', header: 'Sector', sort: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,

    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', sort: true },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
  { accessorKey: 'actions', header: '', sort: true },
];
export const gradeColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },

  {
    accessorKey: 'name',
    header: 'GRADE',
    sort: true,
  },
  {
    accessorKey: 'subCategory',
    header: 'Sector',
    cell: ({ row }) => (
      <div className="px-1">{row?.original?.subCategory?.name}</div>
    ),
    sort: true,
  },
  {
    accessorKey: 'polymerSector',
    header: 'POLYMER SECTOR',
    cell: ({ row }) => (
      <div className="px-1">
        {`${row?.original?.subCategory?.productSubCategory ?? ''}`.trim()}
      </div>
    ),
    sort: true,
  },
  {
    accessorKey: 'mfi',
    header: 'MFI',
    sort: true,
  },
  {
    accessorKey: 'description',
    header: 'DESCRIPTION',
    sort: true,
  },

  {
    accessorKey: 'polymerSectorManufacturer',
    header: 'POLYMER SECTOR MANUFACTURER',
    cell: ({ row }) => (
      <div className="px-1">
        {`${row?.original?.productSubCategoryManufacturer}`.trim()}
      </div>
    ),
    sort: true,
  },
  {
    accessorKey: 'gradeType',
    header: 'Type',
  },
  {
    accessorKey: 'applications',
    header: 'Application',
    size: 300,
    minSize: 300,
    sort: true,
  },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    sort: true,
  },

  { accessorKey: 'status', header: 'STATUS', sort: true },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'specSheet',
    header: 'TDS Sheet',
  },
  { accessorKey: 'actions', header: '', sort: true },
];

export const categoryRequestColumns = [
  { accessorKey: 'name', header: 'CATEGORY', sort: true },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,

    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', sort: true },
];

export const categoryGradeColumns = [
  { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
  {
    accessorKey: 'name',
    header: 'GRADE',
    sort: true,
  },
  {
    accessorKey: 'subCategory',
    header: 'CATEGORY',
    cell: ({ row }) => (
      <div className="px-1">{row?.original?.subCategory?.name}</div>
    ),
    sort: true,
  },
  {
    accessorKey: 'description',
    header: 'DESCRIPTION',
    sort: true,
  },
  {
    accessorKey: 'createdAt',
    header: 'CREATED ON',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,

    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', sort: true },
  {
    accessorKey: 'createdByUserId',
    header: 'Created User ID',
    enableSorting: true,
  },
  {
    accessorKey: 'updatedByUserId',
    header: 'Updated User ID',
    enableSorting: true,
  },
];

export const categoryInitialValues = {
  name: '',
  photo: '',
  document: '',
  status: 'ACTIVE',
};

export const getCategoryInitialValues = (value) => {
  const { id, name, status, photo, document } = value;

  return {
    id,
    name,
    status,
    photo: photo ? photo[0] : photo,
    document: document ? document[0] : document,
  };
};

export const gradeInitialValues = {
  name: '',
  photos: '',
  description: '',
  status: 'ACTIVE',
  specsSheet: '',
  subCategory: '',
  mfi: '',
};

export const getGradeInitialValues = (value) => {
  const {
    id,
    name,
    status,
    photos,
    description,
    specsSheet,
    subCategory,
    gradeType,
    applications,
    mfi,
    manufacturer,
    productSubCategoryManufacturer,
  } = value;

  return {
    id,
    name,
    status,
    description,
    mfi,
    photos: photos ? photos[0] : photos,
    specsSheet: specsSheet ? specsSheet[0] : specsSheet,
    applications,
    subCategory: {
      id: subCategory?.id,
      label: subCategory?.name,
    },
    gradeType: {
      id: gradeType,
      label: gradeType,
    },
    manufacturer,
    productSubCategoryManufacturer,
  };
};

export const productInitialValues = {
  category: '',
  name: '',
  photo: '',
  document: '',
  status: 'ACTIVE',
};

export const getProductInitialValues = (value) => {
  const { id, name, status, photo, document } = value;

  return {
    id,
    name,
    status,
    photo: photo ? photo[0] : photo,
    document: document ? document[0] : document,
    category: { id: value?.category?.id, label: value?.category?.name },
  };
};

export const subCategoryInitialValues = {
  product: '',
  name: '',
  photo: '',
  document: '',
  status: 'ACTIVE',
};

export const getsubCategoryInitialValues = (value) => {
  const { id, name, status, photo, document, product, productSubCategory } =
    value;

  return {
    id,
    name,
    status,
    photo: photo ? photo[0] : photo,
    document: document ? document[0] : document,
    product: { id: product.id, label: product.name },
    productSubCategory,
  };
};

export const CATEGORY_TABS = {
  ALL: 'All',
  ACTIVE_CATEGORY: 'Active',
  INACTIVE_CATEGORY: 'Inactive',
};

export const GRADE_TABS = {
  ALL: 'All',
  ACTIVE_GRADE: 'Active',
  INACTIVE_GRADE: 'Inactive',
};

export const GRADE_TABS_HEADING = {
  ACTIVE_GRADE: 'Active',
  INACTIVE_GRADE: 'Inactive',
};

export const PRODUCT_TABS_HEADING = {
  GRADE: 'Grade',
  CATEGORY: 'Category',
  PRODUCT: 'Product',
  SUBCATEGORY: 'Sector',
};

export const NOTIFICATION_TABS_HEADING = {
  ALL: 'All',
  BIDS: 'Bids',
  ORDERS: 'Orders',
  USERS: 'Users',
  OFFER: 'Offers',
  DEMAND: 'Demands',
  OTHERS: 'Others',
};

export const categoryValidationSchema = Yup.object({
  name: Yup.string('Enter the Category Name')
    .required('Category Name is required')
    .trim(),
});

export const productValidationSchema = Yup.object({
  category: Yup.object('').required('Category is required').nullable(),
  name: Yup.string('Enter the Product Name')
    .required('Product Name is required')
    .trim(),
});

export const subCategoryValidationSchema = Yup.object({
  product: Yup.object('').required('Product is required').nullable(),
  name: Yup.string('Enter the Product Name')
    .required('Product Name is required')
    .trim(),
});

export const gradeValidationSchema = Yup.object({
  name: Yup.string('Enter the Grade Name')
    .required('Grade Name is required')
    .trim(),
  // mfi: Yup.string('Enter the MFI Name').required('MFI Name is required').trim(),
  // category: Yup.object().required('Please Select Category'),
  subCategory: Yup.object().required('Please Select Sector'),

  // gradeImage: Yup.mixed().required('Grade Image is required'),
  photos: Yup.mixed()
    .required('Description Image is required')
    .test(
      'fileType',
      'Only JPG, PNG, GIF and PDF files are allowed',
      (value) =>
        value &&
        (value.includes('.png') ||
          value.includes('.jpg') ||
          value.includes('.jpeg') ||
          value.includes('.gif') ||
          value.includes('.pdf')),
    ),
  specsSheet: Yup.mixed()
    .required('Document is required')
    .test(
      'fileType',
      'Only JPG, PNG, GIF and PDF files are allowed',
      (value) => {
        return (
          value &&
          (value.includes('.png') ||
            value.includes('.jpg') ||
            value.includes('.jpeg') ||
            value.includes('.gif') ||
            value.includes('.pdf'))
          // (value.type === 'image/jpeg' || value.type === 'image/png')
        );
      },
    ),
});
